export const applicationProgressMock = {
  status: 'in-progress',
  progress: 0,
};
